import React from 'react';
import styled from 'styled-components';
import { HeadlineOne } from 'components/atoms/SectionWrapper.style';

const TechnicalScope = styled.div`
  text-align: center;
  margin-top: 100px;
  ul {
    margin-top: 50px;
    text-align: left;
    @media ${({ theme }) => theme.media.tablet} {
      width: 70%;
    }

    li {
      text-align: left;
      margin: 7px;
      font-size: 20px;
      span {
        font-weight: bold;
      }
    }
  }
`;

const ScopeTechnical = () => (
  <>
    <TechnicalScope>
      <HeadlineOne>Zakres czynności w ramach oferty</HeadlineOne>
      <ul>
        <li>
          Weryfikacja potencjału instalacyjnego (analiza możliwości posadowienia
          instalacji od strony formalno-prawnej);
        </li>
        <li>Analiza doboru źródła wytwórczego;</li>
        <li>Analiza doboru źródła wytwórczego;</li>
        <li>Opracowanie projektu koncepcyjnego;</li>
        <li>
          Opracowanie optymalnego modelu ekonomicznego dla wyprodukowanej
          energii;
        </li>
        <li>Opracowanie harmonogramu realizacji inwestycji</li>
      </ul>
    </TechnicalScope>
  </>
);

export default ScopeTechnical;
